import { Checkbox } from '../../../widgets/checkbox';
import { ColorPicker } from '../../../widgets/colorPicker';
import { DialogWindow } from '../../../widgets/dialog';
import { FormControl } from '../../../widgets/formControl';
import { HelpIcon, HelpIconContainer } from '../../../widgets/helpIconContainer';
import { Icon } from '../../../widgets/icon';
import { Input } from '../../../widgets/input';
import { TextArea } from '../../../widgets/textArea';
import { useDropdown } from '../../../widgets/hooks/useDropdown';
import { FC, PropsWithChildren, default as React, useEffect, useRef, useState } from 'react';
import { Unit } from 'src/components/widgets/areaDesigner/helpers';
import { T } from 'src/shared/helpers';
import MdOutlineKeyboardArrowDown from 'src/shared/icons/angle-down-solid.svg';
import MdOutlineKeyboardArrowUp from 'src/shared/icons/angle-up-solid.svg';
import MdKeyboardBackspace from 'src/shared/icons/arrow-left-solid.svg';
// import AlignCenterIcon from 'src/shared/icons/align-center-solid.svg';
// import AlignLeftIcon from 'src/shared/icons/align-left-solid.svg';
// import AlignRightIcon from 'src/shared/icons/align-right-solid.svg';
import RemoveIcon from 'src/shared/icons/times-solid.svg';
import UploadIcon from 'src/shared/icons/upload-solid.svg';
import styled from 'styled-components';
import { PlacementItem, PlacementLayer } from '../placementAreaDesigner';
import QrCodeBarcodeMenu from './qrCodeBarcodeMenu';
import SettingsMenuContent from './settingsMenu';

//TODO andrebbe vincolato ai dpi
export const ppcm = 100;

export type ZIndexType = 'FRONT' | 'BACK';

export type QrBarCodeType = 'qr' | 'code-128';

export type PlacementTool = 'none' | 'pan' | 'multipleSelection';

export type PlacementOutputFileType = 'ONE_FILE_FOR_ALL_DESIGN' | 'ONE_FILE_FOR_EACH_DESIGN';

export enum MenuPages {
    None = 'none',
    InfoArea = 'infoArea',
    Placeholder = 'placeholder',
    UploadPdf = 'uploadPdf',
    Text = 'text',
    Settings = 'settings',
    QrBarCode = 'qrBarCode'
}

export enum Placeholder {
    ProductName = 'product_name',
    VariantName = 'variant_name',
    SellerName = 'seller_name',
    OrderNumber = 'order_number',
    OrderDate = 'order_date',
    Quantity = 'quantity',
    ProductSku = 'product_sku',
    DesignID = 'design_ID',
    DesignDocID = 'design_DocID',
    ModificationID = 'modificationId',
    ProductCode = 'product_code',
    Bulk = 'bulk'
}

export enum ItemType {
    TEXT = 'TEXT',
    QRCODE = 'QRCODE',
    BARCODE128 = 'BARCODE128',
    IMAGE = 'IMAGE'
}

export const DocumentSizeDialogWindow = styled(DialogWindow)`
    max-width: 500px;
    /* height: 250px; */
    height: 320px; //Fix the z-index select
`;

const Button = styled.button<{ $highlight?: boolean }>`
    font-weight: 400;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    background: white;
    color: ${(props) => (props.$highlight ? props.theme.app.primary : 'black')};
    border: 1px ${(props) => (props.$highlight ? props.theme.app.primary : '#DBE2E6')} solid;

    ${(props) =>
        !props.disabled &&
        `
        cursor: pointer;

        @media(hover) {
            &:hover {
                opacity: 0.5;
            }
        }
    `}

    ${(props) =>
        props.disabled &&
        `
            border-color: #DBE2E6;
            color: #DBE2E6;
        `}

    ${Icon}:first-child {
        margin-right: 10px;
        width: 30px;
        height: 30px;
        color: ${(props) => (props.$highlight ? props.theme.app.primary : 'black')};
    }
`;

const IconButton = styled(Button)`
    font-size: 12px;
    flex-direction: column;
    justify-content: center;
    border: 0px;
    width: 80px;

    ${Icon}:first-child {
        margin-right: 0;
        width: 18px;
        height: 18px;
    }
`;

const StackMenuButton = styled(Button)`
    min-width: 120px;
    border-radius: 4px;
    padding: 10px;
`;

export interface InfoAreaItem {
    itemName: string;
    sideName: string;
    variantName: string;
    guid: string;
    size: { w: number; h: number };
    position: { x: number; y: number };
    rotation: number;
    unit: string;
    handleChangeItemPosition: (guid: string, value: number, axis: string) => void;
    handleChangeItemRotation: (guid: string, value: number) => Promise<any>;
    handleChangeItemSize: (guid: string, value: number, sizeType: string) => Promise<any>;
}

export interface SettingsMenuContentProps {
    unit: Unit;
    widthCM: number;
    heightCM: number;
    dpi: number;
    name: string;
    containsLayers: boolean;
    stacked: boolean;
    onConfirm: (unit: Unit, widthCM: number, heightCM: number, dpi: number, name: string, stacked: boolean, removeLayers: boolean) => void;
}
export interface QrCodeBarcodeMenuProps {
    onConfirm: (type: QrBarCodeType, data: string, containsPlaceholder: boolean) => void;
}

export const _NoEdgeInput = styled(Input)`
    border-top: none;
    border-right: none;
    border-left: none;
    border-bottom: 1px solid rgb(128, 128, 128);
    border-radius: 0px;
    max-height: 30px;
`;

const Item = styled.div<{ $bold?: boolean; $indented?: boolean; $isLast?: boolean }>`
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 40px;
    color: ${(props) => props.theme.app.textColor};
    border-bottom: ${(props) => (props.$isLast ? 0 : '1px solid #DBE2E6')};
    margin-bottom: ${(props) => (props.$isLast ? 0 : '5px')};

    label {
        font-size: 15px;
        font-weight: ${(props) => (props.$bold ? 700 : 400)};
        margin-left: ${(props) => (props.$indented ? '15px' : '0')};
        text-overflow: ellipsis;
    }
`;

const SubItem = styled.div`
    display: flex;
    /* margin-left: 15px; */
    flex-direction: column;
`;

// -------- Bulk Form ---------

const BulkFormContainer = styled.div`
    display: flex;
    flex-direction: column;
`;

interface BulkFormProps {
    sides: { sideID: number; name: string }[];
    selectedSides: number[];
    selectedAll: boolean;
    onSelectedSide: (sideID: number) => void;
    onSelectAll: (value: boolean) => void;
}

export const BulkForm: FC<BulkFormProps> = ({ sides, selectedSides, selectedAll, onSelectedSide, onSelectAll }) => {
    return (
        <BulkFormContainer>
            <Item $bold>
                <label> {T._('All variants', 'Admin')}</label>
                <Checkbox checked={selectedAll} onChange={() => onSelectAll(!selectedAll)} />
            </Item>

            {sides.map((side) => {
                return (
                    <Item key={side.sideID}>
                        <label> {T._('All ', 'Admin') + side.name}</label>
                        <Checkbox checked={selectedSides.includes(side.sideID)} onChange={() => onSelectedSide(side.sideID)} />
                    </Item>
                );
            })}
        </BulkFormContainer>
    );
};

// -----------Placeholder menu page---------------

const ContainerStackMenuButton = styled.div`
    display: flex;
    flex-direction: column;
    gap: 5px;
`;

export const PlaceholderButtons: FC<{ onButtonClick: (value: string) => void }> = ({ onButtonClick }) => {
    return (
        <ContainerStackMenuButton>
            <MenuButton onClick={() => onButtonClick(Placeholder.ProductName)}>{T._('Product Name', 'Admin')}</MenuButton>
            <MenuButton onClick={() => onButtonClick(Placeholder.VariantName)}>{T._('Variant Name', 'Admin')}</MenuButton>
            <MenuButton onClick={() => onButtonClick(Placeholder.SellerName)}>{T._('Seller Name', 'Admin')}</MenuButton>
            <MenuButton onClick={() => onButtonClick(Placeholder.OrderNumber)}>{T._('Order Number', 'Admin')}</MenuButton>
            <MenuButton onClick={() => onButtonClick(Placeholder.OrderDate)}>{T._('Order Date', 'Admin')}</MenuButton>
            <MenuButton onClick={() => onButtonClick(Placeholder.Quantity)}>{T._('Quantity', 'Admin')}</MenuButton>
            <MenuButton onClick={() => onButtonClick(Placeholder.ProductSku)}>{T._('Product sku', 'Admin')}</MenuButton>
            <MenuButton onClick={() => onButtonClick(Placeholder.DesignID)}>{T._('DesignID', 'Admin')}</MenuButton>
            <MenuButton onClick={() => onButtonClick(Placeholder.ModificationID)}>{T._('ModificationID', 'Admin')}</MenuButton>
            <MenuButton onClick={() => onButtonClick(Placeholder.DesignDocID)}>{T._('DesignDocID', 'Admin')}</MenuButton>
            <MenuButton onClick={() => onButtonClick(Placeholder.ProductCode)}>{T._('Product Code', 'Admin')}</MenuButton>
            <MenuButton onClick={() => onButtonClick(Placeholder.Bulk)}>{T._('bulk (yes/no?)', 'Admin')}</MenuButton>
        </ContainerStackMenuButton>
    );
};

export const PlaceholderMenu: FC<{ onButtonClick: (value: string) => void; onBackButtonClick?: () => void }> = ({ onButtonClick, onBackButtonClick }) => {
    return (
        <MenuPage
            title={T._('Placeholder', 'Admin')}
            description={T._('Use the following placeholders to add dynamic content to the pdf', 'Admin')}
            showBackButton
            onBackButtonClick={onBackButtonClick}
        >
            <PlaceholderButtons onButtonClick={onButtonClick} />
        </MenuPage>
    );
};

// -----------Text menu page---------------

const ColorBox = styled.div<{ color: string }>`
    border: 1px solid #ddd;
    width: 20px;
    height: 20px;
    border-radius: 20px;
    background-color: ${(props) => props.color};
    cursor: pointer;
`;

export const TextMenu: FC<{
    item?: PlacementItem | undefined | null;
    handleAreaChanged: (value: string, fontFamily: string, fontColor: string, alignment: 'left' | 'center' | 'right') => void;
    onBackButtonClick?: () => void;
}> = ({ item, handleAreaChanged, onBackButtonClick }) => {
    const [text, setText] = useState<string>(item?.content ?? '');
    const [fontFamily, setFontFamily] = useState<string>(item?.fontFamily ?? 'Adamina');
    const [textColor, setTextColor] = useState<string>(item?.color ?? '#000000');
    const [textAlignment, setTextAlignment] = useState<'left' | 'center' | 'right'>(item?.textAlignment ?? 'center');
    const [setOpen, setClose, isOpen, Dropdown] = useDropdown();
    const inputRef = useRef<HTMLTextAreaElement>(null);

    useEffect(() => {
        handleAreaChanged(text, fontFamily, textColor, textAlignment);
    }, [text, textAlignment, textColor]);

    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.focus();
            inputRef.current.setSelectionRange(text.length, text.length);
        }
    }, [inputRef]);

    return (
        <MenuPage title={T._('Text', 'Admin')} showBackButton onBackButtonClick={onBackButtonClick}>
            <ContainerStackMenuButton>
                <FormControl>
                    <TextArea
                        ref={inputRef}
                        placeholder={T._('Insert your text', 'Admin')}
                        value={text}
                        rows={4}
                        onChange={(e) => {
                            setText(e.target.value);
                        }}
                    />
                </FormControl>
                {/* <Item>
                    <label> {T._('Font ', 'Admin')}</label>
                    <AdvancedSelect
                        isSearchable={true}
                        options={[
                            {
                                value: "Adamina",
                                label: T._('Adamina', 'Admin')
                            },
                            {
                                value: "Permanent Marker",
                                label: T._('Permanent Marker', 'Admin')
                            },
                            {
                                value: "Montserrat",
                                label: T._('Montserrat', 'Admin')
                            },
                            {
                                value: "sans-serif",
                                label: T._('sans-serif', 'Admin')
                            }]}
                        placeholder={T._('Select font...', 'Admin')}
                        onChange={option => {
                            setFontFamily(option.value);
                            if (option.value && text.length > 0) {
                                handleAreaChanged(text, option.value, textColor);
                            }
                        }}
                        isMulti={false}
                        styles={{
                            menu: (prev) => ({
                                ...prev,
                                width: "auto",
                                zIndex: 3
                            }),
                            control: (provided, state) => ({
                                ...provided,
                                border: "none",
                                boxShadow: "none",
                                "&:hover": {
                                    border: "none",
                                },
                                ...(state.menuIsOpen && {
                                    borderColor: "transparent",
                                    boxShadow: "none",
                                })
                            }),
                            indicatorSeparator: () => ({
                                display: "none",
                            }),
                        }}
                        value={fontFamily ?? null} />
                </Item> */}
                <Item>
                    <label> {T._('Text Color', 'Admin')}</label>
                    <ColorBox
                        color={textColor}
                        onClick={(e) => {
                            e.stopPropagation();
                            setOpen(e.currentTarget, 'right', 'top');
                        }}
                    ></ColorBox>
                    {isOpen && (
                        <Dropdown>
                            <ColorPicker availableColors={null} color={textColor} onChange={(color) => setTextColor(color)} />
                        </Dropdown>
                    )}
                </Item>
                {/* <Item>
                    <label> {T._('Font Size', 'Admin')}</label>
                    <label>{item?.fontSize}</label>
                </Item> */}
                {/* <Item>
                    <label> {T._('Style', 'Admin')}</label>
                </Item> */}
                {/* <Item>
                    <label> {T._('Alignment', 'Admin')}</label>
                    <div>
                        <ItemIcon selected={textAlignment === "left"}><AlignLeftIcon onClick={() => setTextAlignment("left")} /></ItemIcon>
                        <ItemIcon selected={textAlignment === "center"} ><AlignCenterIcon onClick={() => setTextAlignment("center")} /></ItemIcon>
                        <ItemIcon selected={textAlignment === "right"}><AlignRightIcon onClick={() => setTextAlignment("right")} /></ItemIcon>
                    </div>
                </Item> */}
            </ContainerStackMenuButton>
        </MenuPage>
    );
};

// -----------Upload pdf menu page---------------

export const UploadPdfMenu: FC<{
    variants: { colorID: number; name: string }[];
    layers: PlacementLayer[];
    onButtonClick: (colorID: number) => void;
    onRemove: (colorID: number) => void;
    onBackButtonClick?: () => void;
}> = ({ variants, layers, onButtonClick, onRemove, onBackButtonClick }) => {
    const generalLayer = layers.find((l) => l.colorID === -1);

    return (
        <MenuPage
            title={T._('Upload', 'Admin')}
            showBackButton
            onBackButtonClick={onBackButtonClick}
            description={T._('The PDFs size must be the same as the document size', 'Admin')}
        >
            <ContainerStackMenuButton>
                <Item $bold>
                    <label>{T._('General', 'Admin')}</label>
                    {(!generalLayer || (generalLayer && !generalLayer.fileID && !generalLayer.fileObjectID)) && (
                        <AreaItemIcon $hoverable onClick={() => onButtonClick(-1)}>
                            <UploadIcon />
                        </AreaItemIcon>
                    )}
                    {generalLayer && (generalLayer.fileID || generalLayer.fileObjectID) && (
                        <AreaItemIcon $hoverable onClick={() => onRemove(-1)}>
                            <RemoveIcon />
                        </AreaItemIcon>
                    )}
                </Item>
                {variants.length > 0 && variants.every((x) => x.colorID !== 1) && (
                    <AreaItem title={T._('Variants', 'Admin')}>
                        <SubItem>
                            {variants.map((variant, j) => {
                                const currentLayer = layers.find((l) => l.colorID === variant.colorID);

                                return (
                                    <Item key={j} $isLast={j === variants.length - 1} $indented>
                                        <label> {variant.name} </label>
                                        {(!currentLayer || (currentLayer && !currentLayer.fileID && !currentLayer.id)) && (
                                            <AreaItemIcon $hoverable onClick={() => onButtonClick(variant.colorID)}>
                                                <UploadIcon />
                                            </AreaItemIcon>
                                        )}
                                        {currentLayer && (currentLayer.fileID || currentLayer.id) && (
                                            <AreaItemIcon $hoverable onClick={() => onRemove(variant.colorID)}>
                                                <RemoveIcon />
                                            </AreaItemIcon>
                                        )}
                                    </Item>
                                );
                            })}
                        </SubItem>
                    </AreaItem>
                )}
            </ContainerStackMenuButton>
        </MenuPage>
    );
};

// ---------------Info area---------------------

const TitleContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

const Container = styled.div`
    display: flex;
    flex-direction: column;
    border-bottom: 1px solid #dbe2e6;
    padding-bottom: 5px;
`;

const Title = styled.h2`
    font-size: 15px;
    font-weight: 700;
    margin-right: auto;
    color: ${(props) => props.theme.app.textColor};
`;

const AreaItemIcon = styled(Icon)`
    height: 22px;
    margin-left: auto;
    color: ${(props) => props.theme.app.textColor};
`;

const ItemIcon = styled(Icon)<{ $selected?: boolean }>`
    height: 20px;
    cursor: pointer;
    margin-left: 5px;
    border: ${(props) => (props.$selected ? '1px' : '0')} #979393 solid;
`;

const AreaItem: FC<{ title?: React.ReactNode; children?: React.ReactNode }> = ({ title, children }) => {
    const [opened, setOpened] = useState<boolean>(true);

    return (
        <>
            <Container>
                <TitleContainer>
                    <Title>{title}</Title>
                    {!opened && (
                        <AreaItemIcon $hoverable onClick={() => setOpened(!opened)}>
                            <MdOutlineKeyboardArrowDown />
                        </AreaItemIcon>
                    )}
                    {opened && (
                        <AreaItemIcon $hoverable onClick={() => setOpened(!opened)}>
                            <MdOutlineKeyboardArrowUp />
                        </AreaItemIcon>
                    )}
                </TitleContainer>
                {opened && <div>{children}</div>}
            </Container>
        </>
    );
};

const InfoAreaMenuContainer = styled.div`
    display: flex;
    flex-direction: column;
`;

const PropertyContainer = styled.div`
    flex: 1;
    display: flex;
    gap: 5px;
`;

const InfoContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 0 10px;
`;

export const InfoAreaMenu: FC<{ force: string; items: InfoAreaItem[]; onBackButtonClick?: () => void }> = ({ force, items, onBackButtonClick }) => {
    return (
        <MenuPage title={T._('Info', 'Admin')} showBackButton onBackButtonClick={onBackButtonClick}>
            <ContainerStackMenuButton>
                {items.map((item) => {
                    return <ItemComponent item={item} />;
                })}
            </ContainerStackMenuButton>
        </MenuPage>
    );
};

export const ItemComponent: FC<{ item: InfoAreaItem }> = ({ item }) => {
    const [itemState, setItemState] = useState(item);

    const title =
        (itemState.itemName || 'Area') + (itemState.sideName ? ', ' + itemState.sideName : '') + (itemState.variantName ? ', ' + itemState.variantName : '');
    return (
        <AreaItem key={itemState.guid} title={title}>
            <InfoAreaMenuContainer>
                <InfoContainer>
                    <Section label={T._('Size', 'Admin')}></Section>
                    <Section label={T._('w', 'Admin')} disabled={itemState.sideName ? true : false}>
                        <NoEdgeInput
                            value={itemState.size.w.toString()}
                            placeholder={T._('w', 'Admin')}
                            type='number'
                            step={1}
                            onChange={async (newValue) => {
                                itemState.size.w = newValue;
                                setItemState({ ...itemState });
                                await itemState.handleChangeItemSize(itemState.guid, newValue, 'width').then((itemSize: any) => {
                                    if (itemSize) {
                                        itemState.size.h = itemSize.h;
                                        setItemState({ ...itemState });
                                    }
                                });
                            }}
                        />
                    </Section>
                    <Section label={T._('h', 'Admin')} disabled={itemState.sideName ? true : false}>
                        {/* <label>{item.size.h}</label> */}
                        <NoEdgeInput
                            value={itemState.size.h.toString()}
                            placeholder={T._('h', 'Admin')}
                            type='number'
                            step={1}
                            onChange={async (newValue) => {
                                itemState.size.h = newValue;
                                setItemState({ ...itemState });
                                await itemState.handleChangeItemSize(itemState.guid, newValue, 'height').then((itemSize: any) => {
                                    if (itemSize) {
                                        itemState.size.w = itemSize.w;
                                        setItemState({ ...itemState });
                                    }
                                });
                            }}
                        />
                    </Section>

                    <Section label={T._('Position', 'Admin')}></Section>
                    <Section label={T._('x', 'Admin')}>
                        <NoEdgeInput
                            value={itemState.position.x.toString()}
                            placeholder={T._('x', 'Admin')}
                            type='number'
                            step={1}
                            onChange={(newValue) => {
                                itemState.handleChangeItemPosition(itemState.guid, newValue, 'x');
                                itemState.position.x = newValue;
                                setItemState({ ...itemState });
                            }}
                        />
                    </Section>
                    <Section label={T._('y', 'Admin')}>
                        <NoEdgeInput
                            value={itemState.position.y.toString()}
                            placeholder={T._('y', 'Admin')}
                            type='number'
                            step={1}
                            onChange={(newValue) => {
                                itemState.handleChangeItemPosition(itemState.guid, newValue, 'y');
                                itemState.position.y = newValue;
                                setItemState({ ...itemState });
                            }}
                        />
                    </Section>
                </InfoContainer>

                <Section label={T._('Rotate', 'Admin')}>
                    <Section label={T._('°', 'Admin')}>
                        <NoEdgeInput
                            value={itemState.rotation.toString() ? itemState.rotation.toFixed(2) : '0'}
                            placeholder={T._('0', 'Admin')}
                            type='number'
                            step={1}
                            onChange={async (newValue) => {
                                itemState.rotation = newValue;
                                setItemState({ ...itemState });
                                await itemState.handleChangeItemRotation(itemState.guid, newValue).then((itemCoord: any) => {
                                    if (itemCoord) {
                                        itemState.size.w = itemCoord.w;
                                        itemState.size.h = itemCoord.h;
                                        itemState.position.x = itemCoord.x;
                                        itemState.position.y = itemCoord.y;
                                        setItemState({ ...itemState });
                                    }
                                });
                            }}
                        />
                    </Section>
                </Section>
            </InfoAreaMenuContainer>
        </AreaItem>
    );
};
// -----------Bulk Menu ---------------

export const BulkMenu: FC<{ children?: React.ReactNode; onBackButtonClick?: () => void }> = ({ children, onBackButtonClick }) => {
    return (
        <MenuPage title={T._('Bulk Add', 'Admin')} showBackButton onBackButtonClick={onBackButtonClick}>
            <ContainerStackMenuButton>{children}</ContainerStackMenuButton>
        </MenuPage>
    );
};

// -----------Model Area Menu ---------------

export const ModelAreaMenu: FC<{ children?: React.ReactNode; rightIcon?: { icon: React.ReactNode; onRightIconClick: () => void } }> = ({
    children,
    rightIcon
}) => {
    return (
        <MenuPage title={T._('Bulk Add', 'Admin')} rightIcon={rightIcon} highlight>
            <ContainerStackMenuButton>{children}</ContainerStackMenuButton>
        </MenuPage>
    );
};

// -----------Settings Menu ---------------
export const SettingsMenu: FC<SettingsMenuContentProps> = ({ unit, widthCM, heightCM, dpi, name, containsLayers, stacked, onConfirm }) => {
    return (
        <MenuPage title={T._('Output settings', 'Admin')}>
            <SettingsMenuContent
                widthCM={widthCM}
                heightCM={heightCM}
                dpi={dpi}
                unit={unit}
                name={name}
                containsLayers={containsLayers}
                stacked={stacked}
                onConfirm={onConfirm}
            />
        </MenuPage>
    );
};

// -----------Qr and bar code Menu ---------------
export const QrBarCodeMenu: FC<QrCodeBarcodeMenuProps> = ({ onConfirm }) => {
    return (
        <MenuPage title={T._('Qr code / Barcode', 'Admin')}>
            <QrCodeBarcodeMenu onConfirm={onConfirm} />
        </MenuPage>
    );
};

// --------------Menupage--------------

interface MenuPageProps {
    title?: string;
    description?: string;
    children?: React.ReactNode;
    showBackButton?: boolean;
    rightIcon?: { icon: React.ReactNode; onRightIconClick: () => void };
    onBackButtonClick?: () => void;
    highlight?: boolean;
}

const MenuPageContainer = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
    /* align-items: stretch; */
`;

const MenuPageTitle = styled.h2<{ $highlight?: boolean }>`
    font-size: 15px;
    font-weight: 700;
    margin-top: 0;
    margin-bottom: 30px;
    display: flex;
    align-items: center;
    color: ${(props) => (props.$highlight ? props.theme.app.secondary : props.theme.app.textColor)};
`;

const Description = styled.span`
    font-size: 12px;
    font-weight: 400;
    margin-bottom: 15px;
`;

const MenuIcon = styled(Icon)`
    height: 20px;
`;

const MenuPageContent = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    overflow: auto;
    /* padding: 0 5px */
`;
export const MenuPage: FC<MenuPageProps> = ({ title, description, children, showBackButton, rightIcon, highlight, onBackButtonClick }) => {
    return (
        <MenuPageContainer>
            <MenuPageTitle $highlight={highlight}>
                {showBackButton && onBackButtonClick && (
                    <MenuIcon $hoverable onClick={onBackButtonClick}>
                        <MdKeyboardBackspace />
                    </MenuIcon>
                )}
                {title}
                {rightIcon && (
                    <MenuIcon $hoverable onClick={rightIcon.onRightIconClick}>
                        {rightIcon.icon}
                    </MenuIcon>
                )}
            </MenuPageTitle>
            {description && <Description>{description}</Description>}
            <MenuPageContent>{children}</MenuPageContent>
        </MenuPageContainer>
    );
};

// ----------MenuButton-------------

interface MenuButtonProps {
    onClick: React.MouseEventHandler<HTMLButtonElement>;
    highlight?: boolean;
    disabled?: boolean;
    icon?: React.ReactNode;
    children?: React.ReactNode;
    customStyle?: React.CSSProperties;
}

export const MenuButton: FC<MenuButtonProps> = ({ onClick, highlight, icon, disabled, children }) => {
    return (
        <StackMenuButton onClick={onClick} $highlight={highlight} disabled={disabled}>
            {icon && <Icon>{icon}</Icon>}
            {children}
        </StackMenuButton>
    );
};

// -----------MenuIconButton-------------

export const MenuIconButton: FC<MenuButtonProps> = ({ onClick, highlight, icon, disabled, children, customStyle }) => {
    return (
        <IconButton style={customStyle} onClick={onClick} $highlight={highlight} disabled={disabled}>
            {icon && <Icon>{icon}</Icon>}
            {children}
        </IconButton>
    );
};

//-------------SectionContainer--------------

const SectionContainer = styled.div<{ disabled?: boolean }>`
    display: flex;
    align-items: center;
    padding: 0 0 5px 0;
    font-size: 13px;
    height: 35px;

    ${(props) =>
        props.disabled &&
        `
        cursor: pointer;
		pointer-events:none;
        opacity: 0.5;
    `}

    label {
        margin-right: auto;
        /* margin-left: 10px; */
        font-size: 13px;
    }

    > div {
        display: flex;
        gap: 15px;

        > input {
            max-width: 80px;
        }
    }
`;

export const Section: FC<PropsWithChildren<{ label?: string; tooltip?: string; onIconTooltipClick?: () => void; disabled?: boolean }>> = ({
    label,
    tooltip,
    onIconTooltipClick,
    disabled = false,
    children
}) => (
    <SectionContainer disabled={disabled}>
        <label>
            {label}
            {tooltip && (
                <HelpIconContainer onClick={onIconTooltipClick} tooltip={tooltip}>
                    <HelpIcon />
                </HelpIconContainer>
            )}
        </label>

        <div>{children}</div>
    </SectionContainer>
);

//-------------NoEdgeInput--------------

export const NoEdgeInput: FC<{ value: string; placeholder: string; type: string; step: number; onChange: (value: number) => void }> = ({
    value,
    placeholder,
    type,
    step,
    onChange
}) => {
    return (
        <_NoEdgeInput
            value={value}
            placeholder={placeholder}
            type={type}
            step={step}
            onChange={async (e) => {
                const newValue = e.target.valueAsNumber;
                if (!isNaN(newValue)) {
                    await onChange(newValue);
                }
            }}
        />
    );
};

//-------------StaticComponentContainer--------------

const StaticComponentContainer = styled.div<{ disabled?: boolean }>`
    display: flex;
    align-items: center;
    padding: 0 0 5px 0;
    font-size: 13px;
    height: 35px;
    max-width: 80px;

    ${(props) =>
        props.disabled &&
        `
        cursor: pointer;
        opacity: 0.5;
    `}

    label {
        font-size: 13px;
    }

    > div {
        display: flex;
        gap: 15px;
        margin-left: 10px;
    }
`;

export const StaticComponent: FC<PropsWithChildren<{ label?: string; disabled?: boolean }>> = ({ label, children, disabled }) => (
    <StaticComponentContainer disabled={disabled}>
        <label>{label}</label>
        <div>{children}</div>
    </StaticComponentContainer>
);
